import { Outlet, useParams } from "react-router-dom";
import { useGetWallQuery } from "wall/api/walls.endpoints";
import QueryWrapper from "common/components/QueryWrapper";
import { PlayLayout } from "common/layouts/PlayLayout";
import { useMantineTheme } from "@mantine/core";
import { useGetEventQuery } from "event/api/event.api";
import {
  DEFAULT_WHITE_COLOR,
  DEFAULT_PSG_BACKGROUND_MOBILE,
} from "_graphic_design";

export function WallPlayThemeWrapper() {
  const { wallId, eventId } = useParams<{ wallId: string; eventId: string }>();
  const getWallQuery = useGetWallQuery(wallId!);
  const getEventQuery = useGetEventQuery(eventId!);
  const theme = useMantineTheme();

  return (
    <QueryWrapper queries={[getWallQuery, getEventQuery]}>
      {([wall, event]) => {
        const gameTheme = {
          colors: {
            background: event.colors.eventBackgroundColor || "#131527",
            text: wall.colors.info || DEFAULT_WHITE_COLOR,
          },
          images: {
            playBackground:
              wall.images.playBackground || DEFAULT_PSG_BACKGROUND_MOBILE,
          },
        };
        return (
          <PlayLayout theme={gameTheme}>
            <div style={{ fontFamily: theme.fontFamily }}>
              <Outlet />
            </div>
          </PlayLayout>
        );
      }}
    </QueryWrapper>
  );
}
